import React from 'react';
import { Route } from 'react-router-dom';
import FacultyResearch from '@/pages/research/FacultyResearch';

export const researchRoutes = (
  <React.Fragment>
    <Route path="research" element={<FacultyResearch />} />
    <Route path="research/publications" element={<FacultyResearch />} />
    <Route path="research/projects" element={<FacultyResearch />} />
    <Route path="research/patents" element={<FacultyResearch />} />
    <Route path="research/workshops" element={<FacultyResearch />} />
  </React.Fragment>
);
